import React,{useRef,useState,useEffect} from 'react'
import { useReactToPrint } from 'react-to-print';
import { useParams } from 'react-router-dom';
import { useAlert } from '../../../../../../context/AlertContext';
import voucherServices from '../voucherServices';
import companyServices from '../../company/companyServices';
import partyServices from '../../party/partyServices';
import { useAppData } from '../../../../../../context/AppDataContext';
import { CancelOutlined, CheckCircle, Email, Phone, Print } from '@mui/icons-material';
import PaymentReceiptVoucherForm from '../component/PaymentReceiptVoucherForm';
import { NumberToWords } from '../section/NumberToWords';
import { CircularProgress, Dialog, DialogContent } from '@mui/material';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import VoucherPaymentItemList from '../section/VoucherPaymentItemList';

function PaymentReceiptVoucherDetailsPage() {
  const {id} = useParams();
  const printComponentRef = useRef();
  const {AppAlert} = useAlert();
  const [dialogStatus,setDialogStatus] = useState(false);
  const {getMasterLabel, partyDD, ledgerDD,getDDDataById} = useAppData();
  const [voucherDetails,setVoucherDetails] = useState(null);
  const [companyDetails,setCompanyDetails] = useState(null);
  const [pendingAllocation,setPendingAllocation] = useState("");
  

  const getVoucherDetails = () =>{
    console.log("voucher id is ",id)
    voucherServices.getById(id).then(res=>{
      setVoucherDetails(res.data);
    }).catch(error=>{
      console.log(error);
    })
  }

  useEffect(()=>{
    getVoucherDetails();
  },[id])


  
    const getComapnyDetails = () =>{
        companyServices.getById(voucherDetails.companyId).then(res=>{
            setCompanyDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
        })
    }

    useEffect(()=>{
        if(voucherDetails){
            getComapnyDetails();
        }
    },[voucherDetails])

  
  const printVoucher = () =>{
    setTimeout(handlePrint,100)
  }
  
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
    // Standard A4 or Letter size logic
    pageStyle: `
        @page { 
            size: auto; 
            margin: 10mm; 
        }
        @media print {
            body { -webkit-print-color-adjust: exact; }
        }
    `
  });


  const finalize =() =>{
    if(pendingAllocation != 0){
      AppAlert("Payment allocation is required prior to finalization.","error")
      return false;
    }
    setDialogStatus(true);

    voucherServices.paymentReceiptFinalize(id).then(res=>{
      AppAlert(res.msg);
    }).catch(error=>{
      AppAlert(error.msg,"error")
    }).finally(()=>{
      getVoucherDetails();
      setDialogStatus(false);
    })
  }

  const discard =() =>{
    setDialogStatus(true);
    voucherServices.paymentReceiptDiscard(id).then(res=>{
      AppAlert(res.msg);
    }).catch(error=>{
      AppAlert(error.msg,"error")
    }).finally(()=>{
      getVoucherDetails();
      setDialogStatus(false);
    })
    
  }

  return (
    <FinanceLayout>
      <style>
        {
          `
          table {page-break-after:unset}
          `
        }
      </style>
      {voucherDetails && companyDetails && 
        <div className='container'>
          <Dialog
            open={dialogStatus}
            keepMounted
            fullWidth={true}
            maxWidth="md"
          >
            <DialogContent>
              <div className='text-center'><CircularProgress /></div>
              <div className='text-center'>Saving In Progress</div>
            </DialogContent>
          </Dialog>
          <div className='row mb-2'>
              <div className='col-md-12'>
                <div className='col-md-12'>
                    {voucherDetails.status === 1 && 
                      <PaymentReceiptVoucherForm data={voucherDetails} callBack={getVoucherDetails} voucherType={voucherDetails.voucherType} />
                    }
                    {voucherDetails.status === 2 && 
                      <>
                      <button className='btn btn-outline-success ms-2'>Finalized <CheckCircle/> </button>
                      <button className='btn btn-outline-danger float-end ms-2' onClick={discard} ><CancelOutlined/> Discard</button>
                      </>
                    }
                    {voucherDetails.status === 1 && 
                      <button className='btn btn-outline-primary float-end ms-2' onClick={finalize} ><CheckCircle/> Finalize</button>
                    }

                    {voucherDetails.status === 3 && 
                      <button className='btn btn-outline-danger ms-2'> Discarded Invoice <CancelOutlined/> </button>
                    }
                    <button className='btn btn-outline-primary float-end ms-2' onClick={printVoucher} ><Print /> Print</button>
                    
                  </div>
              </div>
          </div>
          <div ref={printComponentRef} >
            <div className='row'>
              <div className='col-md-12'>
                <div className='text-center'>
                    <div className='fw-bold' style={{ fontSize: 14 }}>{companyDetails.companyName}</div>
                    <div>{companyDetails.address}</div>
                    <div>{companyDetails.city}, {getMasterLabel("indian-state", companyDetails.state)} - {companyDetails.zip}</div>
                    <div className='mt-1'>
                        <span className='fw-bold'>GSTIN: </span>{companyDetails.gst.toUpperCase()}
                    </div>
                    <div className='small text-muted'>
                        <Email style={{ fontSize: 12 }} /> {companyDetails.email} | <Phone style={{ fontSize: 12 }} /> {companyDetails.phone}
                    </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className='text-center mt-3'>
                  <h4 className='fw-bold'>{voucherDetails.voucherType} Voucher</h4>
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-12'></div>  
              <div className='col-6'>No: <span className='fw-bold'> {voucherDetails.voucherNo} </span></div>
              <div className='col-6'><span className='float-end'>Date: {voucherDetails.voucherDate}</span> </div>
            </div>
            <div className='row mt-2'>
              <div className='col-md-12'>
                  <table className='table table-sm table-bordered mb-0' style={{ fontSize: 12 }}>
                    <thead style={{ fontSize: 14 }}>
                      <tr className=''>
                        <th>Perticulars</th>
                        <th width="20%">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                      <tr>
                        <td>
                          <div className='fw-bold'>Through :</div>
                          <div className='ms-5' style={{fontSize:14}}>{getDDDataById(ledgerDD,voucherDetails.paymentLedgerId)?.label}</div>
                        </td>
                        <td></td>
                      </tr>
                      
                    </tbody>

                    <tfoot>
                        <tr>
                          <td>
                            <div className='fw-bold'>Account : </div>
                            <div className='ms-5' style={{fontSize:14}}>{getDDDataById(partyDD,voucherDetails.partyId).label}</div>
                          </td>
                          <td>
                            <span style={{fontSize:14}} className='fw-bold'>{Number(voucherDetails.grandTotal).toLocaleString('en-IN')}</span>
                          </td>
                        </tr>
                        {voucherDetails.instrumentNo !== "" &&
                        <tr>
                          <td>
                            <div className='fw-bold'>Instrument No : </div>
                            <div className='ms-5' style={{fontSize:14}}>{voucherDetails.instrumentNo}</div>
                          </td>
                          <td></td>
                        </tr>
                        }
                    </tfoot>
                  </table>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-12'>
                <VoucherPaymentItemList voucherDetails={voucherDetails} pendingAllocation={pendingAllocation} setPendingAllocation={setPendingAllocation}  />
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-6'>
                Receiver's Signature:
              </div>
              <div className='col-6 '>
                <span className='float-end'>Authorised Signatory:</span>
              </div>
            </div>         
          </div> 
        </div>
      }
    </FinanceLayout>
  )
}

export default PaymentReceiptVoucherDetailsPage